import React from "react";
import TBBImage from "utils/TBBImage";

const WorkHeader = ({blok}) => {
  return (
    <div className="relative overflow-hidden">
        {!blok.asset.filename?.includes(".mp4") && blok.asset.filename &&  
            <TBBImage image={blok.asset} className={`w-full h-full object-cover ${blok.mobile_asset.filename && 'md:block hidden'}`}/>
        }
        {!blok.mobile_asset.filename?.includes(".mp4") && blok.mobile_asset.filename &&  
            <TBBImage image={blok.mobile_asset} className={`w-full h-full object-cover md:hidden block`}/>
        }
        {blok.asset.filename?.includes(".mp4") && blok.asset.filename && 
            <div className="block w-full h-full object-cover">
                <video width="1920" height="1080" muted controlsList="nodownload" autoPlay loop playsInline className={`${blok.mobile_asset.filename?.includes(".mp4") ? 'hidden md:block' : 'block'} w-full h-full object-cover`}>
                    <source src={blok.asset.filename} type="video/mp4"/>
                    Sorry, your browser doesn't support embedded videos.
                </video>
                {blok.mobile_asset.filename?.includes(".mp4") && blok.mobile_asset.filename && 
                <video width="1920" height="1080" muted controlsList="nodownload" autoPlay loop playsInline className="md:hidden block w-full h-full object-cover ">
                    <source src={blok.mobile_asset.filename} type="video/mp4"/>
                    Sorry, your browser doesn't support embedded videos.
                </video>
                }
            </div>
        }
    </div>
  );
};

export default WorkHeader;